import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
export function Close() {
  return <section className="stage relative w-full text-white" data-id="element-55" data-mp="1zyh2w7skw2x2">
      <div className="wave-strip h-1.5 w-full" aria-hidden="true" data-id="element-56" data-mp="1uycqasusjsc4" />
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-57" data-mp="1uwi47b7s9u6g">
        <h2 className="font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-58" data-mp="1pygkco2j9qtx">
          Stop prepping on Sunday nights. <span className="text-amber" data-id="element-59" data-mp="1l1gby6i7obzn">Start walking in ready.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-60" data-mp="1g8n8rn2e5bpo">
          Six volumes, 134 ready-to-run sessions and five bonuses. A full year of
          public speaking — confidence, impromptu, structure, delivery, persuasion
          and performance — every session at three levels, printable and ready to teach.
        </p>

        <div className="mt-7" data-id="element-61" data-mp="12bi6ly5sswzp">
          <Countdown size="sm" tone="dark" data-id="element-62" data-mp="xa2ly77j8shu" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-amber bg-ink-deep/60 px-5 py-4 text-left" data-id="element-63" data-mp="xcnmmsw3h2e0">
          <div data-id="element-64" data-mp="41j0qz8qx9y5">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-amber" data-id="element-65" data-mp="4226lhl4g7vt">Complete package</span>
            <span className="text-[15px] font-semibold text-white" data-id="element-66" data-mp="3lfedlgbv8pw5">52 Weeks of Speaking — 6 Volumes + 5 Bonuses</span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-67" data-mp="hzz20anua88w">
            <span className="text-[15px] text-white/60 line-through" data-id="element-68" data-mp="hyflqk26nx74">$97</span>
            <span className="font-display text-4xl font-extrabold leading-none text-white" data-id="element-69" data-mp="mz3fhdhsqs51">$27</span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-70" data-mp="84ozzmxfy0v4">
          <CtaButton data-id="element-71" data-mp="d0e7qdjm6o2i">Yes, I want my speaking year done — $27</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-72" data-mp="2ssad9onpwzqp">
          {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-73" data-mp="149fnm1vretq7">
              <span className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-74" data-mp="14b0g7lyik2lf" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}